export default {"src":"/_next/static/media/dark-logo.a3d04f7d.svg","height":60,"width":310,"blurWidth":0,"blurHeight":0};